<div class="external-dashboard">
    @if (url) {
        <iframe [src]="url"
                (load)="frameLoaded()"></iframe>
    }

    @if (noLinkFound) {
        <div class="alert alert-warning">We could not find any external link to display.</div>
    }
</div>
